<template>
  <Form>
    <div class="create-profile-wrapper">
      <div class="form-progress-wrap edit-profile basic-info-wrap">
        <div class="container">
          <div class="steps-content">
            <div class="general-form-wrap player-detail-form-wrap box-wrapper">
              <div class="heading">
                <h2 class="form-title">
                  {{
                    workingTypeNew
                      ? "Add New Player"
                      : `${player.fname} Details Edit`
                  }}
                </h2>
              </div>
              <div class="roster-edit-form coach-edit-form">
                <BaseDragUpload
                  :image-url="player.profileImage"
                  cannot-delete
                  @file-upload="image => handleImageUpload(image)"
                  label="Click this area to upload player image"
                />
                <FormModel
                  class="roster-form-wrapper"
                  :rules="validationRules"
                  :model="player"
                  ref="form"
                >
                  <a-row :gutter="32">
                    <a-col :sm="24" :md="8">
                      <BaseFormInput
                        :value="player.fname"
                        label="First Name"
                        placeholder="Enter First Name"
                        @change="
                          event =>
                            handleValueChange(event.target.value, 'fname')
                        "
                        name="fname"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseFormInput
                        :value="player.mname"
                        label="Middle Name"
                        placeholder="Enter Middle Name"
                        @change="
                          event =>
                            handleValueChange(event.target.value, 'mname')
                        "
                        name="mname"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseFormInput
                        :value="player.lname"
                        label="Last Name"
                        placeholder="Enter Last Name"
                        @change="
                          event =>
                            handleValueChange(event.target.value, 'lname')
                        "
                        name="lname"
                      />
                    </a-col>
                    <a-col :sm="24" :md="24">
                      <BaseTaxonomySelect
                        resource="playerPosition"
                        name="positionValue"
                        type="Player Position"
                        :value="player.positionValue"
                        label="Position"
                        placeholder="Select position"
                        mode="multiple"
                        @change="value => handleSelect(value, 'positionValue')"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseInputGroup
                        label="Height (Feet ~ Inches)"
                        compact
                        class="height-wrapper"
                        name="heightInFeet"
                      >
                        <BaseInput
                          class="feet-input"
                          type="number"
                          :min="0"
                          :value="Number(player.heightInFeet)"
                          @change="
                            event =>
                              handleValueChange(
                                event.target.value,
                                'heightInFeet'
                              )
                          "
                        />
                        <BaseInput
                          class="divider-input"
                          disabled
                          placeholder="~"
                        />
                        <BaseInput
                          class="inch-input"
                          type="number"
                          :min="0"
                          :value="Number(player.heightInInch)"
                          @change="
                            event =>
                              handleValueChange(
                                event.target.value,
                                'heightInInch'
                              )
                          "
                        />
                      </BaseInputGroup>
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseFormInput
                        :value="player.highSchool"
                        label=" School"
                        placeholder="Enter School"
                        name="highSchool"
                        @change="
                          event =>
                            handleValueChange(event.target.value, 'highSchool')
                        "
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseFormInput
                        :value="player.city"
                        label="City"
                        placeholder="Enter City"
                        @change="
                          event => handleValueChange(event.target.value, 'city')
                        "
                        name="city"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseSortedTaxonomySelect
                        resource="playerState"
                        type="College State"
                        name="stateId"
                        :value="player.stateId"
                        label="State"
                        placeholder="Select State"
                        @change="value => handleSelect(value, 'stateId')"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseTaxonomySelect
                        resource="battingHand"
                        type="Bats"
                        name="battingHandId"
                        :value="player.battingHandId"
                        label="Batting Hand"
                        placeholder="Select Batting Hand"
                        @change="value => handleSelect(value, 'battingHandId')"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseTaxonomySelect
                        resource="throwingHand"
                        type="Throws"
                        :value="player.throwingHandId"
                        label="Throwing Hand"
                        name="throwingHandId"
                        placeholder="Select Throwing Hand"
                        @change="value => handleSelect(value, 'throwingHandId')"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseSelect
                        label="Grad Year"
                        placeholder="Select Graduation Year"
                        :items="years"
                        :value="player.gradeYear"
                        label-path="label"
                        value-path="value"
                        name="gradeYear"
                        @change="value => handleSelect(value, 'gradeYear')"
                      />
                    </a-col>
                    <a-col :sm="24" :md="8">
                      <BaseFormInput
                        name="profileLink"
                        :value="player.profileLink"
                        label="Profile Link"
                        placeholder="Enter Premium Player Profile Links Only"
                        @change="
                          event =>
                            handleValueChange(event.target.value, 'profileLink')
                        "
                      />
                    </a-col>
                  </a-row>
                  <div class="footer-button-wrapper">
                    <div class="submit-button">
                      <BaseButton
                        type="primary"
                        :loading="playerLoading"
                        @click="handleFormSubmit"
                        >{{
                          workingTypeEdit ? "Update" : "Create New"
                        }}</BaseButton
                      >
                    </div>
                    <div class="extra-buttons">
                      <BaseButton
                        type="danger"
                        @click="backToList"
                        class="first-child-wrapper"
                        >Back to List</BaseButton
                      >
                    </div>
                  </div>
                </FormModel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Form>
</template>

<script>
import { Roster } from "@/models";
import { mapGetters } from "vuex";
import { FormModel } from "ant-design-vue";

const STORE_KEY = "rosterStore";

export default {
  components: {
    FormModel
  },
  props: {
    type: {
      type: String,
      default: "edit"
    }
  },
  data() {
    return {
      imageSrc: null,
      validationRules: Roster.validationRules(),
      player: new Roster(),
      years: Roster.nYears(10),
      hasImage: null,
      image: null
    };
  },
  computed: {
    ...mapGetters({
      playerLoading: `${STORE_KEY}/playerLoading`,
      storePlayer: `${STORE_KEY}/player`
    }),
    workingTypeNew() {
      return this.type === "new";
    },
    workingTypeEdit() {
      return this.type === "edit";
    },
    profileId() {
      return Roster.profileId();
    }
  },
  methods: {
    async handleFormSubmit() {
      if (!this.image && !this.hasImage) {
        this.$notification.error({
          message: "Image Is Compulsory",
          description: "Please Upload an Image"
        });
      }
      this.$refs.form.validate(async valid => {
        if (valid && (this.image || this.hasImage)) {
          const action = this.type === "edit" ? "editPlayer" : "createPlayer";
          await this.$store.dispatch(`${STORE_KEY}/${action}`, {
            clubCoachId: localStorage["profile-id"],
            clubId: localStorage["club-id"],
            fname: this.player.fname,
            mname: this.player.mname || "",
            lname: this.player.lname,
            city: this.player.city,
            state: this.player.stateId,
            heightInFeet: this.player.heightInFeet,
            heightInInch: this.player.heightInInch,
            battingHand: this.player.battingHandId,
            throwingHand: this.player.throwingHandId,
            gradeYear: this.player.gradeYear,
            id: this.player.id,
            highSchool: this.player.highSchool,
            position: this.player.positionValue,
            profileLink: this.player.profileLink,
            slug: "clubroster"
          });
          let formData = new FormData();
          formData.append("file", this.image);
          if (this.image) {
            await this.$store.dispatch(`${STORE_KEY}/uploadImage`, {
              image: formData,
              id: this.storePlayer.id
            });
          }
          this.$router.push(`/${this.profileId}/club_profile/roster`);
        }
      });
    },
    handleValueChange(value, key) {
      this.player = new Roster({ ...this.player, [key]: value });
    },
    backToList() {
      this.$router.push(`/${this.profileId}/club_profile/roster`);
    },
    handleSelect(value, key) {
      this.player = new Roster({ ...this.player, [key]: value });
    },
    handleImageUpload(image) {
      this.image = image;
    }
  },
  watch: {
    storePlayer: {
      deep: true,
      handler: function(newVal) {
        this.player = new Roster({ ...newVal });
        this.hasImage = Boolean(this.player.profileImage);
      }
    }
  }
};
</script>

<style lang="scss">
.height-wrapper {
  .ant-input-group {
    top: 1px !important;
  }
  .feet-input {
    width: 40% !important;
    text-align: center !important;
  }
  .divider-input {
    width: 20% !important;
    border-left: 0 !important;
    border-right: 0 !important;
    pointer-events: none !important;
    background-color: #fff !important;
    text-align: center !important;
  }
  .inch-input {
    width: 40% !important;
    text-align: center !important;
    border-left: 0 !important;
  }
}
</style>
